import { render, staticRenderFns } from "./DocumentSignatureCustomization.vue?vue&type=template&id=00239e03"
import script from "./DocumentSignatureCustomization.vue?vue&type=script&lang=js"
export * from "./DocumentSignatureCustomization.vue?vue&type=script&lang=js"
import style0 from "./DocumentSignatureCustomization.vue?vue&type=style&index=0&id=00239e03&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports